/* global $, Swiper, SGLink, jQuery, sgData */
import DebugConsole from './debug/debug-console';

const logger = DebugConsole();

(function () {
  $.sgHelpers = $.sgHelpers || {};

  /**
   * Creates a client side maintained list of recently viewed products
   * @param {Object} [scriptOptions] Options for the scripts
   * @param {number} [shopNumber] A shop number
   * @returns {Object} jQuery chain object
   */
  $.fn.shopgateItemHistory = function (scriptOptions, shopNumber) {
    const defaults = {
      minItemsBeforeShow: 1,
      scrollable: false,
      slidesPerView: 'auto',
      imageSize: 135,
      showName: false,
      action: 'init',
    };

    if (sgData && sgData.device && sgData.device.type === 'Tablet') {
      // Bad hack to get a different value for this option without adjusting every call of
      // this function. Before the tablets had their own copy of this script, with basically
      // only this difference.
      defaults.slidesPerView = 5;
      defaults.imageSize = 140;
    }

    const options = $.extend(true, {}, defaults, scriptOptions);
    const isApp = sgData && sgData.device && sgData.device.access === 'App';
    let itemHistory = null;
    let showItemHistory = false;
    let itemHistoryLength = 0;


    /**
     * Initializes plugin properties that enable the program to determine, if an item history
     * shall be shown, or not.
     * @private
     */
    function initItemHistory() {
      if ($.sgHelpers && typeof $.sgHelpers.itemHistory === 'object' && shopNumber) {
        // Get the list of recently viewed products
        itemHistory = $.sgHelpers.itemHistory.getHistory(shopNumber, true);

        // Check if it makes sense to show the element
        if (Array.isArray(itemHistory)) {
          itemHistoryLength = itemHistory.length;
        } else {
          itemHistoryLength = 0;
        }

        showItemHistory = itemHistoryLength > options.minItemsBeforeShow;
      }
    }

    initItemHistory();

    if (!showItemHistory) {
      // No recently viewed products - nothing to do here. Take care not to break chaining
      return this;
    }

    return this.each(function () {
      const $that = $(this);
      const $swiperContainer = $that.find('.swiper-container');
      const $itemWrapper = $that.find('.swiper-wrapper');

      const data = $swiperContainer.data();
      const useJsSwiper = !$swiperContainer.hasClass('default');
      const imageSize = data.imageSize || options.imageSize;
      const showName = data.showName || options.showName;
      let swiperReInitTimeout = null;
      let swiperInstance = null;

      /**
       * Reinitialize the current instance, if the product list was changed
       * @private
       */
      function reInitSwiper() {
        window.clearTimeout(swiperReInitTimeout);

        // Do not perform the action at once, because due to 404 image errors, if might be called
        // multiple times within a short time range.
        swiperReInitTimeout = window.setTimeout(() => {
          initItemHistory();

          if (!showItemHistory) {
            $that
              .removeClass('hidden');
          } else {
            if (!swiperInstance) {
              return;
            }
            swiperInstance.reInit();
          }
        }, 200);
      }

      /**
       * Creates a product slider element
       * @param {Object} historyItem - image_url, uid, tags, name
       */
      function createItem(historyItem) {
        // With PI-6165 a system was introduced to handle the issue that the images
        // within the client side stored data sometimes are not available anymore. To be able
        // to watch for errors, an additional parameter has to be injected to the image url to
        // tell the image scripts that is shall respond with an error. It's added dynamically to
        // avoid polluting the original data.
        const imageUrlObject = new SGLink(historyItem.image_url);
        const productLinkObject = new SGLink(historyItem.url);
        imageUrlObject.setParam('404', 1);
        const imageUrl = imageUrlObject.toString();
        // Start building the elements
        const $item = $('<div class="swiper-slide"><div class="content-slide"></div></div>');
        let productLink = productLinkObject.toString();

        if (isApp) {
          productLink = productLinkObject.toSgApiLink().toString();

          // in case the product link contains an invalid url, we sanitize it
          if (productLink.indexOf('sg_app_resources') !== -1) {
            productLink = `sgapi:${productLink.slice(productLink.indexOf('item'))}`;
          }
        }

        const $itemImageLink = $('<a>').attr({
          href: productLink,
          class: 'unveil-parent',
          'data-uid': historyItem.uid,
          'data-tags': historyItem.tags,
        });

        const $itemImage = $('<img>').attr({
          src: 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D',
          class: 'product-history',
          width: imageSize,
          height: imageSize,
          'data-src': imageUrl,
        });

        // append the image
        $itemImageLink.append($itemImage);

        // append title
        if (showName) {
          $itemImageLink.append($('<div class="title">').html(historyItem.name));
        }

        // Combine all single elements
        $item
          .find('.content-slide')
          .append($itemImageLink);

        // Add the constructed element to the list
        $itemWrapper.prepend($item);

        // Register the error listener
        $itemImage.error(() => {
          // Remove the product from the list, if it's image is not available
          $.sgHelpers
            .itemHistory
            .deleteFromShopHistoryByShopItemNumber(shopNumber, historyItem.uid);

          // Remove the item from the list and request a swiper update
          $item.remove();
          reInitSwiper(swiperInstance, swiperReInitTimeout);
        });
      }

      function unveilSlider() {
        // Unveil after swiper built
        $('.product-history', $itemWrapper).unveil(window.screen.height * 2, function () {
          $(this).load(function () {
            $(this).closest('.unveil-parent').css('opacity', 1);
          });
        });
      }

      /**
       * Initialize a product slider
       */
      function init() {
        $itemWrapper
          .empty();

        $that
          .removeClass('hidden');

        $swiperContainer
          .removeAttr('style');

        $itemWrapper
          .removeAttr('style')
          .empty();

        $.each(itemHistory, (index, historyItem) => {
          createItem(historyItem);
        });

        if (itemHistoryLength >= 1) {
          unveilSlider();

          // can cause app crashes on android devices. better use native slider in apps
          if (useJsSwiper) {
            swiperInstance = new window.Swiper($swiperContainer[0], {
              grabCursor: true,
              calculateHeight: true,
              slidesPerView: options.slidesPerView,
              slideActiveClass: '',
              resizeReInit: false,
            });
          }
        }

        $(window).on('orientationchange resize', () => {
          if (!swiperInstance) {
            return;
          }
          swiperInstance.reInit();
        });
      }

      /**
       * Update a already created product slider
       */
      function update() {
        // compare current list with list from localstorage
        if (itemHistoryLength) {
          $that
            .removeClass('hidden');

          let listUpdated = false;
          itemHistory.forEach((element) => {
            // if there are items that are not yet on the list: add them
            if (!$that.find(`a[data-uid=${element.uid}]`).length) {
              listUpdated = true;
              createItem(element);
            }
          });

          if (!listUpdated) {
            return;
          }

          // Unveil after swiper built
          unveilSlider();

          if (!swiperInstance) {
            return;
          }
          swiperInstance.reInit();
        } else {
          $that
            .addClass('hidden');

          $itemWrapper
            .empty();
        }
      }

      if (options.action === 'init') {
        init();
      } else if (options.action === 'update') {
        update();
      }
    });
  };

  $.sgHelpers.itemHistory = {
    version: 2.0,
    storageObject: $.sgHelpers.localStorage,
    storageScope: 'sg_item_history',
    maxItems: 10,
    imageSize: 440,
    useHiddenItem: true,
    itemHistory: null,
    timestamp: null,

    /**
     * Returns a reference for storing history information
     * @param {number} shopNumber The number of the current shop
     * @return {number} The history key
     */
    getHistoryKey(shopNumber) {
      return shopNumber;
    },

    /**
     * Returns an array of history items for the current webapp context
     * @param {number} shopNumber The number of the current shop
     * @param {boolean} [callFromPlugin] Is this function called by the related plugin
     * @return {Array} History items
     */
    getHistory(shopNumber, callFromPlugin) {
      this.timestamp = parseInt((new Date().getTime() / 1000).toFixed(0), 10);

      // get history items form webStorage and the key for the current context
      const itemHistory = this.storageObject.getScopedItems(this.storageScope);
      const itemHistoryKey = this.getHistoryKey(shopNumber);

      if (typeof itemHistory[itemHistoryKey] !== 'object') {
        itemHistory[itemHistoryKey] = {};
        itemHistory[itemHistoryKey].items = [];
      }

      itemHistory[itemHistoryKey].timestamp = this.timestamp;

      // save a reference to history object for global access
      this.itemHistory = itemHistory;
      this.itemHistory.timestamp = this.timestamp;
      this.itemHistory.version = this.version;

      // if the function was called by the plugin some items will not be returned
      if (callFromPlugin) {
        let itemsHandle = itemHistory[itemHistoryKey].items;

        // remove items referenced to the current url
        $.each(itemsHandle, (index, historyItem) => {
          if (
            typeof historyItem !== 'undefined' &&
            typeof historyItem.url !== 'undefined' &&
            historyItem.url === window.location.href) {
            itemsHandle.splice(index, 1);
          }
        });

        // select the correct amount of items for return
        if (itemsHandle.length > this.maxItems) {
          itemsHandle = itemsHandle.slice(itemsHandle.length - this.maxItems, itemsHandle.length);
        }

        itemHistory[itemHistoryKey].items = itemsHandle;
      }

      return itemHistory[itemHistoryKey].items;
    },

    /**
     * Save the item history
     * @param {Array} historyItems Updated history items
     * @param {number} shopNumber The number of the current shop
     * @return {Array|boolean} Updated history items
     */
    saveHistory(historyItems, shopNumber) {
      const itemHistoryKey = this.getHistoryKey(shopNumber);

      // check prerequisites before save
      if (!itemHistoryKey || typeof this.itemHistory !== 'object' || !$.isArray(historyItems)) {
        return false;
      }

      // update the history object with new entries
      this.itemHistory[itemHistoryKey].items = historyItems;
      this.storageObject.setScopedItems(this.storageScope, this.itemHistory);

      return this.itemHistory[itemHistoryKey];
    },

    /**
     * Delete a historyEntry by the shopItemNumber
     * @param {number} shopNumber The number of the current shop
     * @param {string} productNumber The productNumber from the entry which will be delete
     * @returns {Array|boolean} Updated history items, false if the item will be not found
     */
    deleteFromShopHistoryByShopItemNumber(shopNumber, productNumber) {
      const historyEntries = $.sgHelpers.itemHistory.getHistory(shopNumber);
      let itemFound = false;

      $.each(historyEntries, (index, entry) => {
        if (entry.uid.toString() === productNumber.toString()) {
          historyEntries.splice(index, 1);
          itemFound = true;
          return false;
        }

        return true;
      });

      if (!itemFound) {
        return false;
      }

      return this.saveHistory(historyEntries, shopNumber);
    },

    /**
     * Add a new history entry
     * @param {Object} shopItem A shop item record
     * @param {number} shopNumber The number of the current shop
     * @return {Array|boolean} Updated history items
     */
    addEntry(shopItem, shopNumber) {
      /**
       * Create a history item from a shopItem record
       * @param {Object} localShopItem A shop item record
       * @param {number} timestamp Current timestamp
       * @return {Object} The history item
       */
      function prepareHistoryEntry(localShopItem, timestamp) {
        const entry = {
          uid: '',
          tags: '',
        };

        if (localShopItem.is_active === 0 || !localShopItem.is_active) {
          return false;
        }

        if (localShopItem.product_number) {
          entry.uid = localShopItem.product_number;
        }

        if (localShopItem.id) {
          entry.id = localShopItem.id;
        }

        if (localShopItem.name) {
          entry.name = localShopItem.name;
        }

        if ($.isArray(localShopItem.image_urls)) {
          if (localShopItem.image_urls[0][`image_url_${this.imageSize}`]) {
            entry.image_url = localShopItem.image_urls[0][`image_url_${this.imageSize}`];
          }

          // if no image for the desired image size was found... use the first found image
          if (!entry.image_url && localShopItem.image_urls[0]) {
            $.each(localShopItem.image_urls[0], (key, value) => {
              if (key) {
                entry.image_url = value;
                return false;
              }

              return true;
            });
          }
        }

        if (localShopItem.tags) {
          entry.tags = localShopItem.tags;
        }

        const host = `${window.location.protocol}//${window.location.hostname}`;
        entry.url = `${host}/${localShopItem.product_url}`;

        // right url for the testing system
        if (host.indexOf('localdev') >= 0) {
          entry.url = window.location.href;
        }

        if (timestamp) {
          entry.timestamp = timestamp;
        }

        let result = false;

        if (entry.uid && entry.name && entry.image_url && entry.url) {
          result = entry;
        } else {
          console.warn('ItemHistory: Invalid shopItem passed');
        }

        return result;
      }

      // get the current history entries and prepare new entry for the shopItem
      let historyEntries = this.getHistory(shopNumber);
      const newHistoryEntry = prepareHistoryEntry.call(this, shopItem, this.timestamp);

      const maxItems = this.maxItems + (this.useHiddenItem ? 1 : 0);

      if (!newHistoryEntry) {
        logger.warn('Cannot add new history entry. ShopItem invalid.', shopItem);
        return false;
      }

      // if the new item is already present in the history... remove it
      $.each(historyEntries, (index, oldHistoryEntry) => {
        if (oldHistoryEntry.uid === newHistoryEntry.uid) {
          historyEntries.splice(index, 1);
          return false;
        }

        return true;
      });

      // add the new item to the history
      historyEntries.push(newHistoryEntry);

      // reduce history items to the max quantity
      if (historyEntries.length > maxItems) {
        historyEntries = historyEntries
          .slice(historyEntries.length - maxItems, historyEntries.length);
      }

      // save the updated item history
      return this.saveHistory(historyEntries, shopNumber);
    },
  };
})();



// WEBPACK FOOTER //
// ./Library/1.0/common/jquery.shopgate-product-history.js